import { render } from "./EditChambre.vue?vue&type=template&id=87fbb0ec&scoped=true"
import script from "./EditChambre.vue?vue&type=script&lang=js"
export * from "./EditChambre.vue?vue&type=script&lang=js"

import "./EditChambre.vue?vue&type=style&index=0&id=87fbb0ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87fbb0ec"]])

export default __exports__